import React, { useEffect, useState } from "react";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import CommandPalette from "@/components/layout/CommandPalette";
import { useUi } from "@/lib/store";
import { useLocalization } from "@/lib/localization";

export default function WorkspaceShell({ children }) {
  const { setCommandOpen } = useUi();
  const { isRTL } = useLocalization();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCommandOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setCommandOpen]);

  useEffect(() => {
    const desktopBreakpoint = window.matchMedia("(min-width: 1024px)");
    const closeMobileSidebar = (event) => {
      if (event.matches) setMobileSidebarOpen(false);
    };

    desktopBreakpoint.addEventListener("change", closeMobileSidebar);
    return () => desktopBreakpoint.removeEventListener("change", closeMobileSidebar);
  }, []);

  return (
    <div className="h-screen overflow-hidden bg-background text-foreground">
      <Sidebar mobileOpen={mobileSidebarOpen} onMobileOpenChange={setMobileSidebarOpen} />
      <div className={`min-w-0 min-h-0 flex h-full flex-col ${
        isRTL
          ? "lg:mr-[275px] min-[1050px]:max-[1300px]:mr-[250px]"
          : "lg:ml-[275px] min-[1050px]:max-[1300px]:ml-[250px]"
      }`}>
        <Topbar
          mobileSidebarOpen={mobileSidebarOpen}
          onMobileSidebarToggle={() => setMobileSidebarOpen((open) => !open)}
        />
        <main className="flex-1 min-w-0 min-h-0 overflow-y-auto overflow-x-hidden scrollbar-hover">
          {children}
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}
